import { ContactPage } from '@/features/contact/ContactPage';

export function Component() {
  return <ContactPage />;
}
